import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";
import Status from "../../MyComp/UI/form/Status";
import { Badge, Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import OrderComponent from "../../MyComp/UI/form/OrderComponent";
import QualificationComponent from "../../MyComp/UI/form/QualificationComponent";
import EmailInput from "../../MyComp/UI/form/EmailInput";
import DateTimePicker from "../../pages/components/forms/DateTimePicker";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import SelectComponent from "../../MyComp/UI/form/SelectComponent";
import TextAreaInput from "../../MyComp/UI/form/TextAreaInput";
import { Navigate } from "react-router";
import MessageProfileSidebar from "../../pages/panel/e-commerce/support/MessageProfile";
import useLogout from "../../hooks/useLogout";
import { BASE_URL_IMG } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { getZipDetailsAPI } from "../../api/master/indes";
import { addTeleCallerUserAPI, getTeleCallerUserListAPI, updateTeleCallerUserAPI } from "../../api/TellecallerUser";
import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { updateStatusTellecaller } from "../../api/TellecallerUser";

const User = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      name: "",
      email: "",
      mobile: "",
      full_address: "",
      pin_code: "",
      district: "",
      state: "",
      status: true,
    },
  });

  const { logout } = useLogout();

  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("Add");

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      // width: "100px",
    },

    {
      name: "Mobile",
      selector: (row) => <span>{row?.mobile || " "}</span>,
      // width: "119px",
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => <span>{row?.email || " "}</span>,

      wrap: true,
    },


    // {
    //   name: "DOB",
    //   selector: (row) => row?.dob,
    //   sortable: true,
    //   // width: "110px",
    //   wrap: true,
    // },
    // {
    //   name: "Gender",
    //   selector: (row) => row?.gender,
    //   cell: (row) => (
    //     <Badge
    //       className={`text-capitalize`}
    //       pill
    //       color={`${row?.gender == "male" ? "outline-primary" : "outline-danger"}`}
    //     >
    //       {row?.gender || "N/A"}
    //     </Badge>
    //   ),
    //   sortable: true,
    // },
    // {
    //   name: "Full Address",
    //   selector: (row) => `${row?.address || ""}, ${row?.city || ""}, ${row?.state || ""}`,
    //   sortable: true,
    //   // width: "100px",
    // },
    {
      name: "Full Address",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = `${row?.address || ""}, ${row?.city || ""}, ${row?.state || ""}`;

        return (
          <div
            title={fullAddress}   // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 10)}
          </div>
        );
      },
    },
    // {
    //   name: "City",
    //   selector: (row) => row?.city,
    //   sortable: true,
    //   // width: "100px",
    // },
    // {
    //   name: "State",
    //   selector: (row) => row?.state,
    //   sortable: true,
    //   // width: "100px",
    // },
    // {
    //   name: "State",
    //   sortable: true,
    //   wrap: false,
    //   cell: (row) => {
    //     const fullAddress = row?.state || "";

    //     return (
    //       <div
    //         title={fullAddress}   // full text on hover
    //         style={{
    //           maxWidth: "150px",
    //           overflow: "hidden",
    //           cursor: "pointer",
    //         }}
    //       >
    //         {truncateByCharacters(fullAddress, 10)}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   name: "Description",
    //   selector: (row) => row?.description,
    //   wrap: true,
    //   width: "130px",
    // },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "Inactive"}</Badge>
        </div>
      ),
      sortable: true,
      // width: "100px",
    },
    {
      name: "Action",
      // width: "125px",
      cell: (row) => (
        <Button outline color="warning" size="xs" onClick={() => handleEdit(row)}>
          <Icon name="edit" />
        </Button>
      ),
    },
  ];


  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);


  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
    getUserList();
  }, [mode]);

  const getUserList = () => {
    setTableLoading(true);

    getTeleCallerUserListAPI({
      page: currentPage,
      limit: perPage, search: ""
    })
      .then((res) => {
        console.log("API FULL RESPONSE ", res);
        console.log("API DATA ", res?.data);

        setTableLoading(false);

        if (res?.data?.status === true) {
          const list = Array.isArray(res?.data?.data?.teleCallerUserList)
            ? res.data.data.teleCallerUserList
            : res?.data?.data?.teleCallerUserList || [];

          console.log("TABLE DATA ", list);
          setTableData(list);
        } else if (res?.data?.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res?.data?.message || "Failed to fetch users");
        }
      })
      .catch((err) => {
        console.log("API ERROR ", err);
        setTableLoading(false);
        toast.error(err?.response?.data?.message || "API Failed");
      });
  };
  const handlePerRowsChange = (newPerPage, page) => {
    const rows = isNaN(newPerPage) ? totalRows : newPerPage;
    setPerPage(rows);
    setValue("page", page);
    console.log("rows", page, rows);
  };
  const handlePageChange = (page) => {
    console.log("page", page);
    setPerPage(perPage);
    setCurrentPage(page);
    setValue("page", page);
  };

  const onFormSubmit = (formData) => {
    const body = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
      full_address: formData.full_address,
      pin_code: formData.pin_code,
      district: formData.district,
      state: formData.state,
      status: formData?.status?.value ?? true,
      ...(mode === "Edit" && { id: watch("selectedRow").id }),
    };

    setFormLoading(true);

    if (mode === "Add") {
      addTeleCallerUserAPI(body)
        .then((res) => {
          setFormLoading(false);
          if (res.data.status === true) {
            toast.success(res.data.message);
            getUserList();
            setIsOpen(false);
            setMode("Add");
            reset();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          setFormLoading(false);
          toast.error(err?.response?.data?.message);
        });
    }

    if (mode === "Edit") {
      updateTeleCallerUserAPI(body)
        .then((res) => {
          setFormLoading(false);
          if (res.data.status === true) {
            toast.success(res.data.message);
            getUserList();
            setIsOpen(false);
            setMode("Add");
            reset();
          } else if (res.data.status === "expired") {
            toast.error(res.data.message);
            logout();
          } else {
            toast.error(res.data.message);
          }
        })
        .catch((err) => {
          setFormLoading(false);
          toast.error(err?.response?.data?.message);
        });
    }
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    // setValue("user_img",row.image);
    const imageUrl = `${BASE_URL_IMG}${row.image}`;
    setValue("user_image", imageUrl);
    setValue("name", row.name);
    setValue("email", row.email);
    setValue("mobile", row.mobile);
    setValue("description", row.description);
    setValue("full_address", row.address);
    setValue("pin_code", row.pincode);
    setValue("district", row.district_name);
    setValue("state", row.state_name);

    setValue(
      "gender",
      genderOption?.find((item) => item.value === row.gender)
    );

    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
    const body = {
      pin_code: row.pin_code,
    };
    // getZipDetails(body);
  };

  useEffect(() => {
    serverSideSearch();
  }, [perPage, currentPage]);
  const serverSideSearch = (data) => {
    console.log(data, "data");
    const body = {
      search: watch("server_search"),
      page: currentPage,
      limit: perPage,
      search: data ?? "",
    };


    setLoading(true);
    getTeleCallerUserListAPI(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setLoading(false);
          console.log("server side res", res?.data?.data?.result);
          setTotalRows(res?.data?.data?.totalRecords);
          setValue("limit", res?.data?.data?.totalRecords);
          setTableData(res?.data?.data?.teleCallerUserList);
        } else if (status === false) {
          setLoading(false);
          setTableData([]);
        } else if (status === "expired") {
          setLoading(false);
          logout();
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("catch error", err);
      });
  };
  useEffect(() => {
    if (watch("server_search")?.length == 0) {
      serverSideSearch();
    }
  }, [watch("server_search")]);

  const handleToggleStatus = (row) => {
    setSelectedRow(row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const body = {
      id: selectedRow?.id,
      status: !selectedRow?.status,
    };

    setLoading(true);

    updateStatusTellecaller(body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          toast.success(res.data.message);
          serverSideSearch();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      })
      .finally(() => setShowModal(false));
  };

  const genderOption = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
  ];


  useEffect(() => {
    if (watch("pin_code") && watch("pin_code").toString().length === 6) {
      const body = { pin_code: watch("pin_code") };
      getZipDetails(body);
    }
  }, [watch("pin_code")]);

  const getZipDetails = (body) => {
    console.log("get zip details", watch("pincode"));

    setLoading(true);
    getZipDetailsAPI(body)
      .then((res) => {
        setLoading(false);
        if (res.data.status === true) {
          const responseData = res.data.data[0];
          console.log(responseData);

          console.log("zip details", responseData);
          setValue("district", responseData.district_name);
          setValue("state", responseData.state_name);
          trigger(["state", "district"]);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";
    return text.length > charLimit
      ? text.slice(0, charLimit) + "..."
      : text;
  };

  return (
    <>
      <Head title="Users" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Telecaller User
              </BlockTitle>
            </BlockHeadContent>
            {/* Admin not add user (manan sir) */}
            <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  if (!isOpen) {
                    setIsOpen(true);
                    setMode("Add");
                    reset();
                  } else {
                    setIsOpen(false);
                  }
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {isOpen && (
            <PreviewAltCard>
              <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                  <Col md="3">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Name"
                      name="name"
                      placeholder="Enter user name"
                      required
                      min={2}
                      max={50}
                      pattern={/^(?=.*[A-Za-z])[A-Za-z\s.'-]+$/}
                      patternMsg="Name must contain letters and cannot be only spaces"
                    />
                  </Col>
                  <Col md="3">
                    <MyMobile
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Mobile"
                      name="mobile"
                      placeholder="Enter mobile number"
                      required
                      readOnly={mode == "Edit"}
                    />
                  </Col>
                  <Col md="3">
                    <MyEmail
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Email"
                      name="email"
                      placeholder="Enter email"
                      required
                    />
                  </Col>
                  {/* <Col md="3">
                    <MySelect
                      options={genderOption}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Gender"}
                      name={"gender"}
                      placeholder={"select gender"}
                      required
                    />
                  </Col> */}


                  {/* <Col md="3">
                    <MyDate
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="DOB"
                      name="dob"
                      placeholder="select dob"
                      // required
                    />
                  </Col> */}
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Full Address"}
                      name={"full_address"}
                      placeholder={"Enter full address"}
                      pattern={/^(?=.*[A-Za-z0-9])[A-Za-z0-9\s.,'#/\\-]+$/}
                      patternMsg="Address cannot be only spaces and contains invalid characters"
                      required
                      min={5}
                      max={200}
                      disabled={mode == "Approval"}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Pin Code"}
                      name={"pin_code"}
                      placeholder={"Enter pin code"}
                      required
                      min={6}
                      max={6}
                      pattern={/^[0-9]{6}$/}
                      patternMsg="Pin Code must be exactly 6 digits"
                      disabled={mode == "Approval"}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"District"}
                      name={"district"}
                      placeholder={"Enter district"}
                      required
                      min={2}
                      max={100}
                      disabled={mode == "Approval"}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"State"}
                      name={"state"}
                      placeholder={"Enter state"}
                      required
                      min={2}
                      max={100}
                      disabled={mode == "Approval"}
                    />
                  </Col>
                  <Col md="3">
                    <Status
                      register={register}
                      watch={watch}
                      title={"Status"}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                    />
                  </Col>{" "}


                  {/* <Col md="4">
                                  <ImageUpload
                                    getValues={getValues}
                                    design={4}
                                    id="user_image"
                                    watch={watch}
                                    trigger={trigger}
                                    setError={setError}
                                    clearErrors={clearErrors}
                                    label={"Profile Image"}
                                    errors={errors}
                                    register={register}
                                    image={"user_img"}
                                    image_url={"user_image"}
                                    setValue={setValue}
                                    handleImageOpenPreview={handleImageOpenPreview}
                                    required
                                    // validateDoc
                                    // approve={mode === "Approval" ? true : false}
                                    // size={2048}
                                  />
                                </Col> */}
                  {/* <Col md="9">
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Description"
                      name="description"
                      placeholder="Enter user's bio"
                      min={50}
                      max={500}
                      cols={1}
                      row={1}
                    />
                  </Col>{" "} */}
                </Row>{" "}
                <Col md="2">
                  <MyButton isLoading={formLoading} mode={mode} />
                </Col>
              </Form>
            </PreviewAltCard>
          )}

          <ApiPaginationDataTable
            data={tableData}
            columns={columns}
            title="Telecaller Users"
            isLoading={tableLoading}
            register={register}
            trigger={trigger}
            watch={watch}
            setValue={setValue}
            errors={errors}
            totalRows={watch("limit")}
            perPage={watch("perPage")}
            serverSearch
            paginationServer
            serverSideSearch={serverSideSearch}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange} />
        </Block>
      </Content>

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={selectedRow?.status}
      />
    </>
  );
};

export default User;
